import styled from 'styled-components'
import theme from '../../styles/theme'

export const Button = styled.button`
  font-size: 1rem;
  line-height: 1.5;
  padding: 0.5rem 1.5rem;
  display: inline-block;
  appearance: none;
  color: ${({ isModalBtn, isStopAccessBtn }) =>
    isModalBtn
      ? theme.color.action
      : isStopAccessBtn
      ? theme.color.error
      : theme.color.white};
  text-decoration: none;
  border-radius: 4px;
  background-color: ${({ isModalBtn, isStopAccessBtn }) =>
    isModalBtn || isStopAccessBtn ? 'unset' : theme.color.action};
  border: ${({ isStopAccessBtn }) =>
    isStopAccessBtn
      ? `3px solid ${theme.color.error}`
      : `3px solid ${theme.color.action}`};
  cursor: pointer;
  vertical-align: middle;
  transition: background 0.1s ease, border 0.1s ease, color 0.1s ease;
  width: 100%;

  opacity: ${({ disabled }) => (disabled ? '0.4' : 'unset')};

  &:hover {
    background-color: ${theme.color.text};
    border-color: ${theme.color.text};
    text-decoration: underline;
    color: ${theme.color.white};
  }

  &:focus {
    outline: 3px solid ${theme.color.focus};
    outline-offset: 2px;
    border-radius: 0;
  }
`
